import { formatDateYmd, getNextPaymentDate, getPolicyTotalPremium } from './calculations.js'

const escapeIcsText = (value) => String(value || '')
  .replace(/\\/g, '\\\\')
  .replace(/\r?\n/g, '\\n')
  .replace(/;/g, '\\;')
  .replace(/,/g, '\\,')

const formatIcsDate = (date) => formatDateYmd(date).replaceAll('-', '')
const formatTimestamp = (date) => date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z')

export const createPaymentCalendar = (policies = [], options = {}) => {
  const generatedAt = options.generatedAt instanceof Date ? options.generatedAt : new Date()
  const events = []
  let skippedCount = 0

  policies.forEach((policy) => {
    const nextDate = getNextPaymentDate(policy)
    if (!nextDate) {
      skippedCount += 1
      return
    }

    const title = `保单缴费提醒 · ${policy.productName || '未命名保单'}`
    const description = [
      policy.company || '未填写保险公司',
      `被保人：${policy.insuredPerson || '未填写'}`,
      `应缴保费：¥${getPolicyTotalPremium(policy).toLocaleString('zh-CN')}`,
    ].join('\n')
    const date = formatIcsDate(nextDate)
    const uid = `${policy.id || 'policy'}-${date}@policy-manager.local`

    events.push([
      'BEGIN:VEVENT',
      `UID:${escapeIcsText(uid)}`,
      `DTSTAMP:${formatTimestamp(generatedAt)}`,
      `DTSTART;VALUE=DATE:${date}`,
      `SUMMARY:${escapeIcsText(title)}`,
      `DESCRIPTION:${escapeIcsText(description)}`,
      'BEGIN:VALARM',
      'ACTION:DISPLAY',
      'TRIGGER:-P30D',
      `DESCRIPTION:${escapeIcsText(title)}（提前30天）`,
      'END:VALARM',
      'BEGIN:VALARM',
      'ACTION:DISPLAY',
      'TRIGGER:-P7D',
      `DESCRIPTION:${escapeIcsText(title)}（提前7天）`,
      'END:VALARM',
      'END:VEVENT',
    ].join('\r\n'))
  })

  const content = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Policy Manager//Payment Reminder//ZH-CN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'X-WR-CALNAME:保单缴费提醒',
    ...events,
    'END:VCALENDAR',
    '',
  ].join('\r\n')

  return { content, eventCount: events.length, skippedCount }
}
